import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/tenant-templates')({
  component: TenantTemplatesLayout,
});

function TenantTemplatesLayout() {
  return <Outlet />;
}
